import api from "../../database";

export const getInfoForUser = async (codeSend: string, token: string) => {
  const response = await api.get("/transactions/transfer-confirm", {
    params: {
      code: parseInt(codeSend, 10),
    },
    headers: {
      "x-access-token": token,
    },
  });

  return response.data;
};
